import { DefaultTheme } from 'styled-components';

const ingressodevantagensTheme: DefaultTheme = {
  colors : {
    accent : {
      primary : '#FF271A',
      secondary : '#C81F14',
      tertiary : '#FFCC80',
    },
    surface : {
      low : '#F4F6F8',
      base : '#F9FAFB',
      high : '#FFFFFF',
    },
    text : {
      primary : '#212B36',
      secondary : '#454F5B',
      inverted : '#FFFFFF',
    },
    button : {
      text : {
        primary : '#FFFFFF',
        secondary : '#FF271A',
        disabled : '#919EAB',
      },
      surface : {
        primary : '#FF271A',
        secondary : '#FFFFFF',
        disabled : '#DFE3E8',
      },
      hover : {
        primary : '#C81F14',
        secondary : '#FFF3E0',
      },
    },
    pillbutton : {
      text : '#212B36',
      surface : '#FFFFFF',
    },
    tag : {
      socio : '#50B83C',
      coupon : '#009CD6',
      codigo : '#9C6ADE',
      face : '#50248F',
      biometria : '#FFCC80',
      promotional : '#009CD6',
      oGlobo : '#005299',
    },
    border : '#DFE3E8',
    error : '#FF6161',
    success : '#108043',
    warning : '#EEC200',
    info : '#2280EF',
    barColor : '#000000',
  },
  logo : {
    path : 'https://ingresse-static.s3.amazonaws.com/embedstore/ingressodevantagens.svg',
    width : '100px'
  },
  media : {
    mobile : '@media (max-width: 767px)',
  },
  font : {
    family : 'Elza, sans-serif',
    sizes : {
      small : '0.8rem',
      medium : '1rem',
      large : '1.2rem',
    },
  },
};

export default ingressodevantagensTheme;
